import {FC} from 'react';
import {StyledFooterEmailLink} from '@/components/footer/FooterGroup.styles';
import {FooterLinkWithLinkAndLabel} from '@/components/footer/FooterGroup';

type FooterEmailLinkProps = {
    link: FooterLinkWithLinkAndLabel
}

export const FooterEmailLink: FC<FooterEmailLinkProps> = ({
  link
}) => {
  return <StyledFooterEmailLink href={`mailto:${link.link}`}>{link.label}</StyledFooterEmailLink>
}